export default __webpack_public_path__ + "static/media/Cairo-SemiBold.0d18a3d1.ttf";